import { render, staticRenderFns } from "./Rga.vue?vue&type=template&id=50fbc8b8&"
import script from "./Rga.vue?vue&type=script&lang=js&"
export * from "./Rga.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports